import * as React from 'react'
import { styled } from 'next-yak'

import * as models from '@owl-nest/models'

type TrustpilotProps = {
  className?: string
  style?: React.CSSProperties
}

function TrustpilotComponent({ className, style }: TrustpilotProps) {
  const [isLoaded, setIsLoaded] = React.useState(false)
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null)

  React.useEffect(() => {
    const trustpilot = typeof window !== 'undefined' && window.Trustpilot

    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (trustpilot) {
      trustpilot.loadFromElement(ref.current, true)
    }
    setIsLoaded(true)
  }, [])

  const trustPilotLocalizedData = models.i18n.get(
    {
      en: { locale: 'en-GB', url: 'https://trustpilot.com/review/fr.ulule.com' },
      es: { locale: 'es-ES', url: 'https://es.trustpilot.com/review/fr.ulule.com' },
      it: { locale: 'it-IT', url: 'https://it.trustpilot.com/review/fr.ulule.com' },
      nl: { locale: 'nl-NL', url: 'https://nl.trustpilot.com/review/fr.ulule.com' },
      fr: { locale: 'fr-FR', url: 'https://fr.trustpilot.com/review/fr.ulule.com' },
    },
    'en',
  )

  return (
    <Content
      $isLoaded={isLoaded}
      ref={ref}
      className={`trustpilot-widget ${className}`}
      style={style}
      data-locale={trustPilotLocalizedData?.locale}
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="502c50650000640005199c5b"
      data-style-height="24px"
      data-style-width="100%"
    >
      <a href={trustPilotLocalizedData?.url} target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </Content>
  )
}

export const Trustpilot = styled(TrustpilotComponent)<TrustpilotProps>``

const Content = styled.div<{ $isLoaded: boolean }>`
  opacity: ${({ $isLoaded }) => ($isLoaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`
